import React from 'react';
import Logo from "../images/logo.png";

export default function about() {
	document.title = "About - Byokeh Studio";
	let metas = document.getElementsByTagName("meta");
	metas.description.content = ""
	return (
		<>
			<div className="about container">
				<div className="aboutl">
					<img src={Logo} alt="" />
				</div>
				<div className="aboutr">
					<h1>About Byokeh Studio</h1>
					<p>Byokeh Studio is my personal space for creativity—where visuals and technology come together. What started as a solo journey is growing into a vision: to build a studio that tells stories through frames and experiences through code.</p>
					<br />
					<p>I began exploring photography, videography, and coding as ways to create and express ideas. Early on, limited resources made it challenging to dive deep, but persistence kept me moving forward. Today, with the tools I have and the passion I carry, I’m building the foundation for the future I imagine—one where Byokeh Studio evolves into a creative hub that blends art, storytelling, and technology.</p>
					<br />
					<h1>What I Do</h1>
					<p className='p'>Through Byokeh Studio, I currently focus on:</p>
					<ul>
						<li><strong>Web Development</strong></li>
						<li><strong>Photography & Videography (Visual Storytelling)</strong></li>
						<li><strong>Video Editing (Post-Production)</strong></li>
					</ul>
				</div>
			</div>
			<div className="worktools container">
				<h1>Tools I Work With</h1>
				<p className='p'>I believe creativity grows stronger when paired with the right tools. While I’ve started my journey with minimal gear, I continue to push boundaries using the equipment and software I have at hand. <br />My current workflow is powered by:</p>
				<div>
					<div className='eqs'>
						<p className='containertxt'><strong>Equipment</strong></p>
						<ul>
							<li><strong>Nothing Phone 3a (primary camera for photo & video)</strong></li>
							<li><strong>Digitek DSG 010 Pro Gimbal (for stabilized cinematic shots)</strong></li>
							<li><strong>Dell G15 (A capable editing & coding laptop)</strong></li>
						</ul>
					</div>
					<div className='eqs'>
						<p className='containertxt'><strong>Software</strong></p>
						<ul>
							<li><strong>DaVinci Resolve (professional-grade video editing)</strong></li>
							<li><strong>Premier Pro (professional-grade video editing)</strong></li>
							<li><strong>VS Code (coding and development)</strong></li>
						</ul>
					</div>
				</div>
				<br />
				<h1>Looking Ahead</h1>
				<p className='p'>This is just the beginning. I’m working with what I have today while steadily preparing for tomorrow—investing in skills, projects, and eventually, professional gear. Every project I take on brings me one step closer to turning Byokeh Studio into a space where creativity, storytelling, and innovation truly meet.</p>
			</div >
		</ >
	)
}
